import React from 'react'
import {Loader} from 'uikit'
import {isMobileUserAgent} from 'services/app'
import styles from './PageLoader.scss'

export const PageLoader = () => {
  const isMobile = isMobileUserAgent()
  const size = isMobile ? 'small' : 'big'

  return (
    <div className={styles.wrapper}>
      <Loader size={size} />
    </div>
  )
}
